import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import { useState, useEffect, useRef } from "react";
import CreateNewPortfolio from "./createNewPortfolio";
import { getBranchUser } from '../../../Services/userService';
import { list } from '../../../Services/branchService';
import { cloneOpportunity, filter, get } from "../../../Services/opportunityService";
import _ from "lodash";
import { getCustomerFields2, getCustomerFields } from '../../../Services/fieldsServices';
import { getStages } from "../../../Services/optionService";
import HeaderSearchBar from "../../../Components/UiComponents/HeaderSearch";
import MultiSelectElement from "../../../Components/UiComponents/MultiSelectElement";
import DataTable from "../../../Components/UiComponents/DataTable";
import { useNavigate, useLocation } from 'react-router-dom';
import { getBidLeader } from "../../../Services/opportunityService";
import { multiDelete } from "../../../Services/opportunityService";
import { Dialog } from "primereact/dialog";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import SingleSelectElement from "../../../Components/UiComponents/SingleSelectElement";
import InputTextElementElement from "../../../Components/UiComponents/InputTextElement";
import { getField } from "../../../Services/tooltipService";
import { filter as fil } from "../../../Services/clientService";
import { getSeq } from "../../../Services/opportunityService";
import { getModulePermissions } from "../../../Services/pricingPlanService";
import { InputIcon } from "primereact/inputicon";
import Loader from "../../../Components/UiComponents/Loader";
import { get as getCusDet } from "../../../Services/customerServices";
import { useOpportunity } from "../../../Providers/OpportunityContext";
import PlaylistVideos from "../../../Components/Videos/PlaylistVideos";
export default function PortfolioList(props) {
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [showCreateNew, setShowCreateNew] = useState(false);
    const [position, setPosition] = useState('center');
    const [customerId, setCustomerId] = useState(null);
    const [branchIdFromLS, setBranchIdFromLS] = useState();
    const [branchDetails, setBranchDetails] = useState([]);
    const [branches, setBranches] = useState(0);
    const [branchDetail, setBranchDetail] = useState([]);
    const [branch, setBranch] = useState({});
    const [bidLeadersOption, setBidLeadersOption] = useState(null);
    const [bidLeaders, setBidLeaders] = useState(null);
    const [branchId, setBranchId] = useState(null);
    const [pipelineDetails, setPipelineDetails] = useState([]);
    const [customer, setCustomer] = useState({});
    const toastRef = useRef();
    const [planId, setPlanId] = useState(null);
    const [custmerDetails, setCustmerDetails] = useState({});
    const [customerTableData, setCustomerTableData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [clientType, setClientType] = useState([]);
    const [sectorType, setSectorType] = useState([]);
    const [selectedSectorId, setSelectedSectorId] = useState([]);
    const [clientClassificationType, setClientClassificationType] = useState([]);
    const [clientClassificationV3Type, setClientClassificationV3Type] = useState([]);
    const [relationshipOwnerType, setRelationshipOwnerType] = useState([]);
    const [boardSponsorType, setBoardSponsorType] = useState([]);
    const [countryListType, setCountryListType] = useState([]);
    const [businessUnitType, setBusinessUnitType] = useState([]);
    const [branchTypes, setBranchTypes] = useState([]);
    const [projectLeaders, setProjectLeaders] = useState([]);
    const [projectStatus, setProjectStatus] = useState([
        { _id: 2, label: "Active" },
        { _id: 3, label: "Inactive" },
        { _id: 4, label: "Stop" },
        { _id: 5, label: "Won" },
        { _id: 6, label: "Lost" },
    ]);
    const [regionTypes, setRegionTypes] = useState([]);
    const [timePeriod, setTimePeriod] = useState([]);
    const [esgProjectType, setEsgProjectType] = useState([]);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [customerIds, setCustomerIds] = useState([]);
    const [updatedReferenceData, setUpdatedReferenceData] = useState([]);
    const [oppTypes, setOppTypes] = useState([]);
    const [sectorTypes, setSectorTypes] = useState([]);
    const [favourites, setFavourites] = useState([
        { label: 'All', value: 'All' },
        { label: 'Favourites', value: 'Favourites' },
    ]);
    const [regionType, setRegionType] = useState([]);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [stages, setStages] = useState([]);
    const [ids, setIds] = useState([]);
    const [relationshipOwner, setRelationshipOwner] = useState([])
    const [filterPipelineDetails, setFilterPipelineDetails] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchedLength, setSearchedLength] = useState(0);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState([]);
    const [selectedLeader, setSelectedLeader] = useState([]);
    const [selectedLeaderId, setSelectedLeaderId] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedOppType, setSelectedOppType] = useState([]);
    const [selectedOppTypeId, setSelectedOppTypeId] = useState([]);
    const [selectedEsgProjectType, setSelectedEsgProjectType] = useState([]);
    const [selectedEsgProjectTypeId, setSelectedEsgProjectTypeId] = useState([]);
    const [selectedSectorType, setSelectedSectorType] = useState([]);
    const [selectedFavourites, setSelectedFavourites] = useState('All');
    const [favouriteStatus, setFavouriteStatus] = useState([]);
    const [selectedSector, setSelectedSector] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState([]);
    const [selectedRegionId, setSelectedRegionId] = useState([]);
    const [selectedTimePeriod, setSelectedTimePeriod] = useState('All');
    const [selectedTimePeriodId, setSelectedTimePeriodId] = useState('');
    const [selectedBranchId, setSelectedBranchId] = useState([]);
    const [selectedBu, setSelectedBu] = useState(null);
    const [cloneProject, setCloneProject] = useState(false);
    const [moduleNames, setModuleNames] = useState([])
    const [selectedStakeholderId, setSelectedStakeholderId] = useState([]);
    const [selectedClassificationId, setSelectedClassificationId] = useState([]);
    const [selectedBoardSponserId, setSelectedBoardSponserId] = useState([]);
    const [selectedStatusId, setSelectedStatusId] = useState([]);
    const [selectedOwnerId, setSelectedOwnerId] = useState();
    const [selectedBuId, setSelectedBuId] = useState([]);
    const [stakeHolderDetails, setStakeHolderDetails] = useState([]);
    const [projectName, setProjectName] = useState('')
    const [clientName, setClientName] = useState({})
    const [userPrivileges, setUserPrivileges] = useState([])
    const [cloneData, setCloneData] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 25,
        page: -1,
        sortField: 'updated_timestamp',
        sortOrder: 1,
        pattern: "All"
    });
    const [projectFieldsNew, setProjectFieldsNew] = useState([]);
    const [projectSectionsNew, setProjectSectionsNew] = useState([]);
    const [projectSumFields, setProjectSumFields] = useState([]);
    const [commanFieldsNew, setCommanFieldsNew] = useState([]);
    const [clientFieldsNew, setClientFieldsNew] = useState([]);
    const [clientSectionsNew, setClientSectionsNew] = useState([]);
    const [dashBoardFieldsNew, setDashBoardFieldsNew] = useState([]);
    const [commonFields, setCommonFields] = useState([]);
    const [havingBranch, setHavingBranch] = useState(false);
    const [currency, setCurrency] = useState('');
    const [branchSelected, setBranchSelected] = useState(false);
    const [allTimePeriod, setAllTimePeriod] = useState([]);
    const [pricingPlan, setPricingPlan] = useState('');
    const [filterPermissions, setFilterPermissions] = useState({});
    const [tabPermissions, setTabPermissions] = useState({});
    const [columns, setColumns] = useState([])
    const [customerShortName, setCustomerShortName] = useState('')
    const [customerDetails, setCustomerDetails] = useState({});
    const [showVideo, setShowVideo] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    var enduser = localStorage.getItem("user_privileges");
    if (enduser) {
        var tmpPrivilege = JSON.parse(enduser);
        if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
            var addPrivilege = tmpPrivilege[0].opp_add;
            var deletePrivilege = tmpPrivilege[0].opp_delete;
            var editPrivilege = tmpPrivilege[0].opp_edit;
        }
    }

    const [deleted, setDeleted] = useState(false)
    const { setGlobalOpportunityData } = useOpportunity();
    useEffect(() => {
        setGlobalOpportunityData(null)
    }, [])

    useEffect(() => {
        if (deleted) {
            setDeleted(false);
            setIds([]);
            setUpdatedReferenceData([])
        }
    }, [deleted, cloneProject])

    useEffect(() => {
        const enduserStr = localStorage.getItem("enduser");
        if (enduserStr) {
            const enduser = JSON.parse(enduserStr);
            setCustomer(enduser);
            const customer = enduser.customer;
            setCustomerId(customer);
            const branch = enduser.branch;
            setBranchIdFromLS(branch);
        } else {
            navigate("/login")
            localStorage.clear()
        }

        var tmpPrivilegeenduser = localStorage.getItem("user_privileges");
        if (tmpPrivilegeenduser) {
            var tmpPrivilege = JSON.parse(tmpPrivilegeenduser);
            setUserPrivileges(tmpPrivilege)
        }
    }, []);

    useEffect(() => {
        if (customerId && branchIdFromLS) {
            getCustomerFieldDetails();
            // getPortfolioFieldDetails()
            getBranchList();
            getBranchUsers();
            getSelectedStatus();
            getSelectedFavourite();
            getBidLeaders();
        }
    }, [customerId, branchIdFromLS]);


    useEffect(() => {
        if (branch?.branch_id && customerId) {
            getPipelineDetails();
        }
    }, [branch, customerId]);

    useEffect(() => {
        if (lazyParams) {
            getPipelineDetails();
        }
    }, [lazyParams]);

    useEffect(() => {
        if (customerId) {
            getFieldData()
            getCustomerDetails();
        }
    }, [customerId])

    useEffect(() => {
        getStatkeHolderDetails();
    }, [branch, selectedBranchId, selectedStakeholderId, selectedClassificationId,
        selectedBoardSponserId, selectedSectorId, selectedStatusId, selectedOwnerId, selectedFavourites, selectedBuId]);

    useEffect(() => {
        if (pricingPlan) {
            getModulePermission()
        }
    }, [pricingPlan])

    useEffect(() => {
        var cols = [
            // Column configuration for the "Question" field
            {
                field: "opportunity_name", // Data field to map from the row data
                header: headerName, // Header label for the column
                body: checkingProjectName, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "opportunity_alias", // Data field to map from the row data
                header: headerAlias, // Header label for the column
                body: projectAliasName, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "tender_due_filter", // Data field to map from the row data
                header: headerDueDate, // Header label for the column
                body: tenderDuedate, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "tender_due_out_filter", // Data field to map from the row data
                header: headerDueOut, // Header label for the column
                body: tenderDueOutDate, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "opportunity_seq", // Data field to map from the row data
                header: headerSequence, // Header label for the column
                body: opportunitySequence, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "project_alert_flag", // Data field to map from the row data
                header: headerAlert, // Header label for the column
                body: checkingAlert, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true

            },
            {
                field: "business_unit", // Data field to map from the row data
                header: headerBU, // Header label for the column
                body: businessUnit, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "bid_Leader", // Data field to map from the row data
                header: headerBidLeader, // Header label for the column
                body: bidLeader, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "bid_status", // Data field to map from the row data
                header: headerStatus, // Header label for the column
                body: bidStatus, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "winwork_display", // Data field to map from the row data
                header: headerStage, // Header label for the column
                body: stageWinworkDisplay, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "win_score", // Data field to map from the row data
                header: headerScore, // Header label for the column
                body: winScore, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "sector", // Data field to map from the row data
                header: headerSector, // Header label for the column
                body: sector, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "additional.region", // Data field to map from the row data
                header: headerRegion, // Header label for the column
                body: region, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "client_name", // Data field to map from the row data
                header: headerStakeholder, // Header label for the column
                body: stakeholderName, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "opportunity_type", // Data field to map from the row data
                header: headerType, // Header label for the column
                body: projectType, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "contract_value.text", // Data field to map from the row data
                header: headerBudget, // Header label for the column
                body: budgetValue, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            },
            {
                field: "commercial.internal_hours_to_date", // Data field to map from the row data
                header: headerInternal, // Header label for the column
                body: internalHours, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            }
        ]
        if (havingBranch) {
            cols.push({
                field: "branch_name", // Data field to map from the row data
                header: "Branch Name", // Header label for the column
                body: branchName, // Custom renderer for the cell content
                headerClassName: "header-datatable white-space",
                className: 'row-datatable',
                sortable: true
            });
        }
        setColumns(cols);
    }, [pipelineDetails, filterPermissions, havingBranch])

    useEffect(() => {
        if (props.showCreateNew && projectFieldsNew.length > 0) {
            setShowCreateNew(true)
            setVisible(true)
            setPosition('right')
        }
    }, [props.showCreateNew, projectFieldsNew]);

    const getModulePermission = async () => {
        if (pricingPlan) {
            const res = await getModulePermissions(pricingPlan, "Pipeline");

            if (res && res.data) {
                const modulePermissions = res.data;
                if (modulePermissions.status) {
                    var filterPermissions = {};
                    _.filter(modulePermissions.filters, (filter) => {
                        filterPermissions[filter.filter] = filter.status;
                    });
                    setFilterPermissions(filterPermissions);
                }
                if (modulePermissions.status && modulePermissions.sub_modules) {
                    var tabPermissions = {};
                    _.filter(modulePermissions.sub_modules, (sub_module) => {
                        tabPermissions[sub_module.module_name] = sub_module.status;
                    });
                    setTabPermissions(tabPermissions);
                }
            }
        }
    }

    const getSelectedStatus = async () => {
        const selectedStatusParams = getQueryParams()['status']
        const selectedStatusTemp = projectStatus.filter((status) => selectedStatusParams?.includes(status.label))
        if(selectedStatusTemp?.length > 0){
            setSelectedStatus(selectedStatusTemp)
            setSelectedStatusId(selectedStatusTemp?.map(item => item.label))
        }
    }

    const getSelectedFavourite = async () => {
        const selectedFavouriteParams = getQueryParams()['favourite']
        if(selectedFavouriteParams){
            setSelectedFavourites(selectedFavouriteParams)
            setFavouriteStatus(selectedFavouriteParams)
        }
    }

    const getFieldData = async () => {
        try {
            setLoading(true)
            const response = await getField(customerId);

            if (response && response.data) {
                const clientModuleData = response.data;
                setModuleNames(clientModuleData.cust[0].modules)
                var projectModules = _.find(clientModuleData.cust[0].modules, { module_name: "Pipeline" }, true);
                setProjectSectionsNew(_.find(projectModules.sub_modules, { sub_module_name: "NEW", }).sections)
                setProjectFieldsNew(_.find(projectModules.sub_modules, { sub_module_name: "NEW", }).fields)
                setProjectSumFields(_.find(projectModules.sub_modules, { sub_module_name: "Summary", }).fields)

                var commanModules = _.find(clientModuleData.cust[0].modules, { module_name: "Common Fields" }, true);
                setCommanFieldsNew(_.find(commanModules.sub_modules, { sub_module_name: "Common Fields", }).fields);

                var clientModules = _.find(clientModuleData.cust[0].modules, { module_name: "Clients" }, true);
                setClientFieldsNew(_.find(clientModules.sub_modules, { sub_module_name: "NEW", }).fields);
                setClientSectionsNew(_.find(clientModules.sub_modules, { sub_module_name: "NEW", }).sections);

                var dashBoardModules = _.find(clientModuleData.cust[0].modules, { module_name: "Dashboard" }, true);
                setDashBoardFieldsNew(_.find(dashBoardModules.sub_modules, { sub_module_name: "Dashboard filter", }).fields);

                var commonModules = _.find(clientModuleData.cust[0].modules, { module_name: "Common Fields" }, true);
                setCommonFields(_.find(commonModules.sub_modules, { sub_module_name: "Common Fields" }).fields);
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false)
        }
    }
    const getStatkeHolderDetails = async () => {
        try {
            setLoading(true)
            // Fetch stages data from API
            //(skip, limit, cust_id, branch, pattern, sortBy, orderBy, filterData, searchVal)
            const { first, rows, sortField, sortOrder, pattern } = lazyParams;
            if (branch?.branch_id) {
                let data = {
                    skip: first,
                    limit: rows,
                    cust_id: customerId,
                    branch: branch,
                    pattern: pattern,
                    sortBy: sortField,
                    orderBy: sortOrder,
                    filterData: {
                        filter: 'All',
                        branch_id: [],
                        client_classification: [],
                        relationship_owner: [],
                        client_type: [],
                        sector: [],
                        stakeholder_status: [],
                        business_unit: [],
                        region: [],
                        main_board_sponsor: []
                    }
                }

                const stakeholderDetail = await fil(data.skip, data.limit, data.cust_id, data.branch, data.pattern, data.sortBy, data.orderBy, data.filterData);
                if (stakeholderDetail && stakeholderDetail.data && stakeholderDetail.data.client) {
                    setStakeHolderDetails(stakeholderDetail?.data?.client)
                }
            }
        } catch (error) {
            // Log and handle errors
            console.error("Error fetching stages data:", error);
            // toast.error("Failed to fetch stages data");
        } finally {
            setLoading(false)

        }
    };

    const getBidLeaders = async () => {
        try {
            if (customerId) {
                const bidLeaderResponse = await getBidLeader(customerId);
                if (bidLeaderResponse && bidLeaderResponse.data) {
                    setBidLeaders(bidLeaderResponse.data)
                    if (Array.isArray(bidLeaderResponse.data)) {
                        const leaderOptions = bidLeaderResponse.data.map((name) => ({
                            value: name,
                            label: name
                        }));
                        setBidLeadersOption(leaderOptions);
                        const selectedBidLeaderParams = getQueryParams()['leader']
                        const selectedBidLeaders = leaderOptions.filter((item) => selectedBidLeaderParams?.includes(item.label))
                        if (selectedBidLeaders?.length > 0) {
                            setSelectedLeader(selectedBidLeaders?.map((item) => item.value));
                            setSelectedLeaderId(selectedBidLeaders?.map((item) => item.text))
                        }
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching stages data", error);
        }
    };

    // Function to fetch and set stages data
    const getStage = async () => {
        try {
            // Fetch stages data from API
            const stagesResponse = await getStages();
            if (stagesResponse && stagesResponse.data) {
                // Extract and set stages data
                setStages(stagesResponse.data[0].option_choice);
            }

        } catch (error) {
            // Log and handle errors
            console.error("Error fetching stages data:sd", error);
        }
    };

    /**
     * Function to check and render the display name or option names based on availability in the row data.
     * @param {Object} rowData - The data of the row being rendered.
     * @returns {JSX.Element} - The JSX element containing the display name or option names.
     */


    const checkingProjectName = (rowData) => {
        if (rowData.opportunity_name != null && rowData.opportunity_name !== '') {
            return (
                <div className="form-label-text text-left mr-20 pointer mar-l-5"><div key={rowData._id}>{rowData.opportunity_name}</div></div>
            );
        }
    };

    const projectAliasName = (rowData) => {
        if (rowData.opportunity_alias != null && rowData.opportunity_alias !== '') {
            return (
                <div><div key={rowData._id}>{rowData.opportunity_alias}</div></div>
            );
        }
    };

    const tenderDuedate = (rowData) => {
        if (rowData.tender_due != null && rowData.tender_due !== '') {
            return (
                <div><div key={rowData._id}>{rowData.tender_due.text}</div></div>
            );
        }
    };

    const tenderDueOutDate = (rowData) => {
        if (rowData.tender_due_out != null && rowData.tender_due_out !== '') {
            return (
                <div><div key={rowData._id}>{rowData.tender_due_out.text}</div></div>
            );
        }
    };

    const opportunitySequence = (rowData) => {
        if (rowData.opportunity_seq != null && rowData.opportunity_seq !== '') {
            return (
                <div><div key={rowData._id}>{rowData.opportunity_seq}</div></div>
            );
        }
    };

    const businessUnit = (rowData) => {
        if (rowData.business_unit != null && rowData.business_unit !== '') {
            return (
                <div><div key={rowData._id}>{rowData.business_unit}</div></div>
            );
        }
    };

    const checkingAlert = (rowData) => {
        if (rowData.project_alert_flag != null && rowData.project_alert_flag.radio !== '') {
            return (
                // <div><div key={rowData._id}>{rowData.project_alert_flag.radio}</div></div>
                <InputIcon
                    className={
                        rowData?.project_alert_flag?.radio === "yes"
                        && "pi pi-bullseye"
                    }
                    style={{ color: 'red' }}
                />
            );
        }
    };

    const bidLeader = (rowData) => {
        if (rowData.bid_Leader != null && rowData.bid_Leader !== '') {
            return (
                <div><div key={rowData._id}>{rowData.bid_Leader}</div></div>
            );
        }
    };

    const bidStatus = (rowData) => {
        if (rowData.bid_status_display_name != null && rowData.bid_status_display_name !== '') {
            return (
                <div><div key={rowData._id}>{rowData.bid_status_display_name}</div></div>
            );
        }
    };

    const stageWinworkDisplay = (rowData) => {
        if (rowData.winwork_display != null && rowData.winwork_display !== '') {
            return (
                <div><div key={rowData._id}>{rowData.winwork_display}</div></div>
            );
        }
    };

    const winScore = (rowData) => {
        if (rowData.win_score != null && rowData.win_score !== '') {
            return (
                <div><div key={rowData._id}>{rowData.win_score}</div></div>
            );
        }
    };

    const sector = (rowData) => {
        if (rowData.sector != null && rowData.sector !== '') {
            return (
                <div><div key={rowData._id}>{rowData.sector}</div></div>
            );
        }
    };

    const region = (rowData) => {
        if (rowData.additional != null && rowData.additional !== '') {
            return (
                <div><div key={rowData._id}>{rowData.additional.region}</div></div>
            );
        }
    };

    const stakeholderName = (rowData) => {
        if (rowData.client_name != null && rowData.client_name !== '') {
            return (
                <div><div key={rowData._id}>{rowData.client_name}</div></div>
            );
        }
    };

    const projectType = (rowData) => {
        if (rowData.opportunity_type != null && rowData.opportunity_type !== '') {
            return (
                <div><div key={rowData._id}>{rowData.opportunity_type}</div></div>
            );
        }
    };

    const budgetValue = (rowData) => {
        if (rowData.contract_value != null && rowData.contract_value !== '') {
            return (
                <div><div key={rowData._id}>£{rowData.contract_value.text}</div></div>
            );
        }
    };

    const internalHours = (rowData) => {
        if (rowData.commercial != null && rowData.commercial !== '') {
            return (
                <div><div key={rowData._id}>{rowData.commercial.internal_hours_to_date}</div></div>
            );
        }
    };

    const branchName = (rowData) => {
        if (rowData.branch_name != null && rowData.branch_name !== '') {
            return (
                <div><div key={rowData._id}>{rowData.branch_name}</div></div>
            );
        }
    };

    const headerName = () => {
        return _.find(projectFieldsNew, { field_name: 'Project Name' })?.display_name
    }

    const headerAlias = () => {
        return _.find(projectFieldsNew, { field_name: 'Project Alias' })?.display_name
    }

    const headerDueDate = () => {
        return _.find(projectFieldsNew, { field_name: 'Estimated Tender Due Date' })?.display_name
    }

    const headerDueOut = () => {
        return _.find(projectSumFields, { field_name: 'Tender Due Out' })?.display_name
    }

    const headerSequence = () => {
        return _.find(projectSumFields, { field_name: 'Project ID' })?.display_name
    }

    const headerAlert = () => {
        return _.find(projectSumFields, { field_name: 'Project Alert Flag' })?.display_name
    }

    const headerBU = () => {
        return _.find(commanFieldsNew, { field_name: 'Business Unit' })?.display_name
    }

    const headerBidLeader = () => {
        return _.find(projectFieldsNew, { field_name: 'Bid Leader' })?.display_name
    }

    const headerStatus = () => {
        return _.find(projectFieldsNew, { field_name: 'Bid Status' })?.display_name
    }

    const headerStage = () => {
        return _.find(projectFieldsNew, { field_name: 'WinWork Stage' })?.display_name
    }

    const headerScore = () => {
        return _.find(projectFieldsNew, { field_name: 'Win Score' })?.display_name
    }

    const headerSector = () => {
        return _.find(commanFieldsNew, { field_name: 'Sector' })?.display_name
    }

    const headerRegion = () => {
        return _.find(commanFieldsNew, { field_name: 'Region' })?.display_name
    }

    const headerStakeholder = () => {
        return _.find(clientFieldsNew, { field_name: 'Client Name' })?.display_name
    }

    const headerType = () => {
        return _.find(commanFieldsNew, { field_name: 'Services' })?.display_name
    }

    const headerBudget = () => {
        return _.find(projectSumFields, { field_name: 'Total Contract Value' })?.display_name
    }

    const headerInternal = () => {
        return _.find(commanFieldsNew, { field_name: 'Internal Hours to Date' })?.display_name
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e);
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0
        });
        // filteredQuestionsArray(e.target.value)
        setUpdatedReferenceData([])
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0
        });
        filteredQuestionsArray("");
        setUpdatedReferenceData([])
    };

    /**
    * Filters the customer reference data based on the provided query.
    * If the query is empty, it retrieves the full customer field data.
    * 
    * @param {string} query - The search query to filter the customer reference data.
    */

    const filteredQuestionsArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            getPipelineDetails();
            setSearchedLength(lowerCaseQuery.length); // Update the searched length after resetting the data


        } else {
            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }

            // Filter the customer reference data if the query is not empty
            const filteredData = filterPipelineDetails.filter(item => {
                // Check if any value in the item includes the query string
                return Object.values(item).some(value => {
                    // Convert value to string and to lowercase for comparison
                    if (value != null) {
                        return value.toString().toLowerCase().includes(lowerCaseQuery);
                    }
                });
            });

            // Update the state with the filtered data
            setPipelineDetails(filteredData);

        }
    }

    const isEmpty = (obj) => Object.keys(obj).length === 0;
    const getFunctionBasedOnObject = (obj) => {
        if (isEmpty(obj)) {
            return true;
        } else {
            return false;
        }
    };
    const clonePortfolio = async () => {
        const clientDetails = getFunctionBasedOnObject(clientName);
        if (projectName !== '' || !clientDetails) {
            const getSequence = await getSeq(customerId)
            if (getSequence && getSequence.data) {
                var nxtSeq = 1;
                if (!_.isEmpty(getSequence.data)) {
                    nxtSeq = getSequence.data[0].opportunity_seq
                        ? getSequence.data[0].opportunity_seq + 1
                        : 1;
                }
                if (nxtSeq) {
                    if (cloneData !== undefined) {
                        cloneData.opportunity_seq = nxtSeq;
                        cloneData.opportunity_name = projectName;
                        cloneData.client_id = clientName._id;
                        cloneData.client_name = clientName.client_name;
                        cloneData.client = {};
                        cloneData.additional.depth_of_client_engagement = "";
                        cloneData.additional.client_history = "";
                        cloneData.updated_by = customer.username;
                        cloneData.updated_byId = customer.userid;
                        delete cloneData._id;
                        var cloneOpp = await cloneOpportunity(updatedReferenceData[0]._id, cloneData)
                        if (cloneOpp && cloneOpp.data && cloneOpp.data.success) {
                            setProjectName('')
                            setClientName({})
                            setCloneProject(false)
                            nxtSeq = "";
                            toastRef.current.showToast({
                                type: 'success',
                                message: cloneOpp.data.message
                            })
                            getPipelineDetails()
                            setUpdatedReferenceData([])
                            // setTimeout(() => {
                            //     // window.location.reload()
                            //     getPipelineDetails()
                            // }, 1000);
                        } else {
                            setCloneProject(false)
                            toastRef.current.showToast({
                                type: 'error',
                                message: cloneOpp.data.message
                            })
                            getPipelineDetails()
                            setUpdatedReferenceData([])
                            // setTimeout(() => {
                            //     window.location.reload()
                            // }, 1000);
                        }
                    } else {
                        setCloneProject(false)
                        toastRef.current.showToast({
                            type: 'error',
                            message: 'Clone data not fetched'
                        })
                        setUpdatedReferenceData([])
                        // setTimeout(() => {
                        //     window.location.reload()
                        // }, 1000);
                    }
                }
            }

        } else {
            toastRef.current.showToast({
                type: 'error',
                message: 'Fill all the fields'
            })
        }
    }

    const hideCloneDialog = () => {
        setCloneProject(false);
        setProjectName('')
        setClientName({})
        setUpdatedReferenceData([])
        // window.location.reload()
    };

    const cloneFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement type="submit" label="Clone" className="save-button" onClick={clonePortfolio} />
                </div>
            </div>
        );
    };

    const confirmCloneProject = async () => {
        if (userPrivileges[0].opp_edit) {
            setCloneProject(true)
            setProjectName('')
            setClientName('')
            const data = await get(updatedReferenceData[0]._id, customerId, branchIdFromLS, customer.userid)
            if (data && data.data && data.data.opportunity[0]) {
                setCloneData(data.data.opportunity[0])
            }
        } else {
            toastRef.current.showToast({
                type: 'error',
                message: 'Permission Denied'
            });
        }
    }

    const confirmDeleteProduct = () => {
        if (deletePrivilege) {
            setDeleteProductDialog(true);
        } else {
            toastRef.current.showToast({
                type: "error",
                message: "Permission Denied",
            });
        }
    };

    const deleteField = async () => {
        try {
            setLoading(true)
            for (let i = 0; i < ids.length; i++) {
                // Call the API to update the reference data and await the response
                const response = await multiDelete(ids[i], customerIds[i]);
                if (response && response.data && response?.status === 200) {
                    toastRef.current.showToast({
                        type: 'warn',
                        message: `${response.data.message} Successfully`
                    });
                }
                setDeleteProductDialog(false);
                getPipelineDetails();
            }
            setDeleted(true)
            setLoading(false)

        } catch (error) {
            // Log the error for debugging purposes
            toastRef.current.showToast({
                type: 'error',
                message: 'Error'
            })


        }
    }

    /**
    * Removes a field from the customer reference data at the specified index.
    * @param {number} selectedIndex - The index of the field to be removed.
    * @param {Object} data - The updated data to be set after removal.
    */
    const removeField = async (selectedIndex, data) => {
        const ids = [];
        const customerIds = [];

        data.forEach(item => {
            ids.push(item._id);
            customerIds.push(item.customer_id);
        });
        setIds(ids)
        setCustomerIds(customerIds)
        setUpdatedReferenceData(data);
    };

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    };


    // Define the footer for the delete product dialog with action buttons
    const deleteProductDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteProductDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} />
                </div>
            </div>
        );
    };

    const getCustomerDetails = async () => {
        var customerData = await getCusDet(customerId)
        if (customerData && customerData.data) {
            setCustomerDetails(customerData.data)
        }
    }

    const getVersion = (versions) => {
        var currVersion = "v1";
        var found = versions.filter(version => version.checked === true);
        if (found.length) {
            currVersion = found[0].folder;
        }
        return currVersion;
    }

    const checkVersion = (module) => {
        var versions = [];
        var versionAvailble = false;
        for (var i = 0; i < customerDetails.version_maintained?.length; i++) {
            if (customerDetails.version_maintained[i]?.module_name == module) {
                versionAvailble = true;
                versions = customerDetails.version_maintained[i]?.version_detail;
            }
        }
        return {
            versionAvailble: versionAvailble,
            versions: versions
        }
    }


    const rowClick = async (rowData) => {
        if (editPrivilege) {
            if (rowData._id && rowData.opportunity_name) {
                var params = {};
                var versionDetails = checkVersion("Opportunity");
                if (versionDetails.versionAvailble) {
                    params.version = getVersion(versionDetails.versions)
                }
                navigate(`/portfolio/${rowData._id}/${customerShortName}/${params.version}`, { state: { opportunityName: rowData.opportunity_name, opportunity_id: rowData._id } });
            }
        } else {
            toastRef.current.showToast({
                type: "error",
                message: "Permission Denied",
            });
        }
    }

    const resetFilter = () => {
        setSelectedBranch([])
        setSelectedBranchId([])
        setSelectedLeader([])
        setSelectedLeaderId([])
        setSelectedEsgProjectType([])
        setSelectedEsgProjectTypeId([])
        setSelectedSector([])
        setSelectedSectorId([])
        setSelectedOppType([])
        setSelectedOppTypeId([])
        setSelectedBu([])
        setSelectedBuId([])
        setSelectedRegion([])
        setSelectedRegionId([])
        setSelectedStatus([])
        setSelectedStatusId([])
        setSelectedTimePeriod('All')
        setSelectedTimePeriodId('')
        setFavouriteStatus([])
        setSelectedFavourites('All')
        setShowDropdown(false)
        clearAllQueryParams()
        getPipelineDetails()
    }

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown)
    }

    const pipelineVisible = (data) => {
        setVisible(data)
    }

    const getPipelineDetails = async () => {
        setUpdatedReferenceData([])
        setLoading(true)
        try {
            // Fetch stages data from API
            //(skip, limit, cust_id, branch, pattern, sortBy, orderBy, filterData, searchVal)
            if (branch?.branch_id) {
                const { first, rows, sortField, sortOrder } = lazyParams;
                let data = {
                    "bidLeader": "All",
                    "bidStatus": "All",
                    "business_unit": [],
                    "cust_id": customerId,
                    "defAndSec": "true",
                    "filter": "All",
                    "filterBranch": [],
                    "isRestricted": "false",
                    "limit": rows,
                    "loggedInUser": loggedInUser,
                    "orderBy": sortOrder,
                    "search": "",
                    "sector": "All",
                    "skip": first,
                    "sortBy": sortField,
                    "winwork_display": [],
                    "pattern": searchQuery || '',
                    "branch": {
                        "branch_id": branch.branch_id,
                        "branch_key": branch.branch_key
                    },
                    "filterData": {
                        "branch_id": selectedBranchId.length !== 0 ? selectedBranchId : [],
                        "business_unit": selectedBuId?.length !== 0 ? selectedBuId : [],
                        "bid_Leader": selectedLeader?.length !== 0 ? selectedLeader : [],
                        "bidStatus": selectedStatusId.length !== 0 ? selectedStatusId : [],
                        "winwork_display": selectedOppTypeId?.length !== 0 ? selectedOppTypeId : [],
                        "services": selectedEsgProjectTypeId?.length !== 0 ? selectedEsgProjectTypeId : [],
                        "sector": selectedSectorId.length !== 0 ? selectedSectorId : [],
                        "region": selectedRegionId.length !== 0 ? selectedRegionId : [],
                        "timeperiod": selectedTimePeriodId !== '' ? selectedTimePeriodId : "All",
                        "procurement_route": [],
                        "filter": selectedFavourites !== '' ? selectedFavourites : "All",
                        // "timeperiod_range": []
                    }
                }

                if (data.filterData.timeperiod != "All") {
                    data.filterData.timeperiod_range =
                        JSON.stringify(allTimePeriod[data?.filterData?.timeperiod][0]);
                }

                const PipelineDetails = await filter(
                    data.skip,
                    data.limit,
                    data.cust_id,
                    data.pattern,
                    data.search,
                    data.sortBy,
                    data.orderBy,
                    data.filterData,
                    data.isRestricted,
                    data.loggedInUser,
                    data.defAndSec,
                    data.branch
                );
                if (PipelineDetails && PipelineDetails.data) {
                    setPipelineDetails(PipelineDetails?.data?.opp)
                    setFilterPipelineDetails(PipelineDetails?.data?.opp)
                    setTotalRecords(PipelineDetails?.data?.count);
                    setLoading(false)
                }

            }

        }
        catch (error) {
            console.log(error)
        } 
    };

    const getBranchList = async () => {
        if (customerId !== null) {
            try {
                const customerDataResponse = await list(customerId, 'branch_name', -1);
                if (customerDataResponse && customerDataResponse.data) {

                    setBranchDetails(customerDataResponse?.data?.branch);
                    const selectedBranchParams = getQueryParams()['branch']
                    const selectedBranches = customerDataResponse?.data?.branch.filter((branch) => selectedBranchParams?.includes(branch._id))
                    if (selectedBranches?.length > 0){
                        setSelectedBranch(selectedBranches);
                        setSelectedBranchId(selectedBranches?.map((branch) => branch._id));
                    }
                    setBranchId(customerDataResponse?.data?.branch[0]?._id);

                    const allBranches = branch?.data?.branch;
                    let optionList = allBranches?.map((item) => ({
                        id: item._id,
                        label: item.branch_name,
                    }));
                    setBranches(optionList);
                }
            } catch (error) {
                console.error("Error fetching branch fields:", error);
            }
        }
    };

    const getBranchUsers = async () => {
        if (customerId !== null && branchIdFromLS !== null) {
            try {
                const customerDataResponse = await getBranchUser(customerId, branchIdFromLS.branch_id);
                if (customerDataResponse && customerDataResponse.data) {
                    setBranch(customerDataResponse.data[0]?.branch);
                    setBranchDetail(customerDataResponse.data);
                    // setBranchDetails(customerDataResponse?.data?.branch);
                    var relation = customerDataResponse.data.map(o => ({
                        _id: o._id,
                        label: o.firstname + " " + o.surname,
                        status: o.status
                    })
                    )
                    setRelationshipOwner(relation)
                }
            } catch (error) {
                console.error("Error fetching branch fields:", error);
            }
        }
    };

    const getCustomerFieldDetails = async () => {
        // Check if customerId is available
        if (customerId !== null) {
            try {
                // Fetch customer control field data
                const customerData = await getCustomerFields2(customerId);
                if (customerData && customerData.data) {
                    setCustomerTableData(customerData?.data?.cust[0]?.modules)
                    let Stakeholder = _.find(customerData?.data?.cust[0]?.modules, { module_name: "Clients" }).sub_modules
                    if (Stakeholder) {
                        let clientFiltersNew = _.find(Stakeholder, { sub_module_name: "NEW" }).filters;
                        setFilterData(clientFiltersNew)
                    }
                }

            } catch (error) {
                // Handle errors
                console.error("Error fetching customer data", error);
            }
        }
        if (customerId !== null) {
            try {
                const customerData = await getCustomerFields(customerId) // Reference
                if (customerData && customerData.data) {
                    setPlanId(customerData.data.pricing_plan)
                    setCustmerDetails(customerData?.data)
                    setHavingBranch(customerData.data.havingBranch)
                    setCurrency(customerData.data.currency);
                    var customerShort = customerData.data.customer_short;
                    setCustomerShortName(customerShort)
                    if (customerData.data.havingBranch) {
                        setBranchSelected(false)
                    } else {
                        setBranchSelected(true)
                    }
                    setPricingPlan(customerData.data.pricing_plan)

                    let data = customerData?.data.reference_data;

                    let time_period = customerData?.data.time_period
                    setAllTimePeriod(time_period)
                    var tmpPeriod = Object.keys(time_period);
                    var yearLen = tmpPeriod.length / 5;
                    tmpPeriod = tmpPeriod.splice(0, yearLen);
                    var timePeriod = [{ text: "All", value: "All" }];
                    var yearsArr = [];
                    var quartersArr = [];
                    for (var y = 0; y < yearLen; y++) {
                        timePeriod.push({ value: tmpPeriod[y], text: tmpPeriod[y] });
                        yearsArr.push(tmpPeriod[y]);
                        for (var q = 1; q < 5; q++) {
                            timePeriod.push({
                                value: q + "Q" + tmpPeriod[y].toString().substring(2),
                                text: q + "Q" + tmpPeriod[y].toString().substring(2),
                            });
                            quartersArr.push(
                                q + "Q" + tmpPeriod[y].toString().substring(2)
                            );
                        }
                    }
                    setTimePeriod(timePeriod)
                    const selectedTimePeriodParams = getQueryParams()['tp']
                    if (selectedTimePeriodParams) {
                        setSelectedTimePeriodId(selectedTimePeriodParams);
                        setSelectedTimePeriod(selectedTimePeriodParams);
                    }

                    if (customerData?.data.reference_data && data.length !== 0) {
                        const clientTypeData = data.find(
                            (item) => item.option_names === "clientTypeV1"
                        );
                        if (clientTypeData && clientTypeData?.option_choice) {
                            const activeOptions = clientTypeData.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setClientType(activeOptions);
                        }

                        const projectType = data.find(
                            (item) => item.option_names === "WinWorkStage"
                        );
                        if (projectType && projectType?.option_choice) {
                            const activeOptions = projectType.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setOppTypes(activeOptions);
                            const selectedOppTypesParams = getQueryParams()['oppType']
                            const selectedOppTypes = activeOptions.filter((item) => selectedOppTypesParams?.includes(item.text))
                            if (selectedOppTypes?.length > 0) {
                                setSelectedOppType(selectedOppTypes);
                                setSelectedOppTypeId(selectedOppTypes?.map(item => item.text));
                            }
                        }

                        const regionType = data.find(
                            (item) => item.option_names === "Region"
                        );
                        if (regionType && regionType?.option_choice) {
                            const activeOptions = regionType.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setRegionTypes(activeOptions);
                        }


                        const timePeriod = data.find(
                            (item) => item.option_names === "TimePeriod"
                        );
                        if (timePeriod && timePeriod?.option_choice) {
                            const activeOptions = timePeriod.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            // setTimePeriod(activeOptions);
                        }

                        const esgProjectType = data.find(
                            (item) => item.option_names === "Services"
                        );
                        if (esgProjectType && esgProjectType?.option_choice) {
                            const activeOptions = esgProjectType.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setEsgProjectType(activeOptions);
                            const selectedEsgProjectParams = getQueryParams()['esgProject']
                            const selectedEsgProjects = activeOptions.filter((item) => selectedEsgProjectParams?.includes(item.label))
                            if (selectedEsgProjects?.length > 0) {
                                setSelectedEsgProjectType(selectedEsgProjects);
                                setSelectedEsgProjectTypeId(selectedEsgProjects?.map(item => item.label));
                            }
                        }




                        const sectorData = data.find((item) => item.option_names === "SectorV1");
                        if (sectorData && sectorData?.option_choice) {
                            const activeOptions = sectorData.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setSectorType(activeOptions);
                            const selectedSectorParams = getQueryParams()['sector']
                            const selectedSectors = activeOptions.filter((item) => selectedSectorParams?.includes(item.label))
                            if (selectedSectors?.length > 0) {
                                setSelectedSector(selectedSectors);
                                setSelectedSectorId(selectedSectors?.map(item => item.label));
                            }
                        }

                        const ClientClassification = data.find(
                            (item) => item.option_names === "ClientClassificationV1"
                        );
                        if (ClientClassification && ClientClassification?.option_choice) {
                            const activeOptions = ClientClassification.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setClientClassificationType(activeOptions);
                        }

                        const ClientClassificationV3 = data.find(
                            (item) => item.option_names === "ClientClassificationV3"
                        );
                        if (ClientClassificationV3 && ClientClassificationV3?.option_choice) {
                            const activeOptions = ClientClassificationV3.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setClientClassificationV3Type(activeOptions);
                        }
                        const relationshipOwner = data.find(
                            (item) => item.option_names === "RelationshipOwner"
                        );
                        if (relationshipOwner && relationshipOwner?.option_choice) {
                            const activeOptions = relationshipOwner.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setRelationshipOwnerType(activeOptions);
                        }

                        const boardSponsor = data.find(
                            (item) => item.option_names === "BoardSponsor"
                        );
                        if (boardSponsor && boardSponsor?.option_choice) {
                            const activeOptions = boardSponsor.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setBoardSponsorType(activeOptions);
                        }

                        const countryList = data.find(
                            (item) => item.option_names === "CountryList"
                        );
                        if (countryList && countryList?.option_choice) {
                            const activeOptions = countryList.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setCountryListType(activeOptions);
                        }

                        const businessUnit = data.find(
                            (item) => item.option_names === "BusinessUnit"
                        );
                        if (businessUnit && businessUnit?.option_choice) {
                            const activeOptions = businessUnit.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setBusinessUnitType(activeOptions);
                            const selectedBusinessUnitParams = getQueryParams()['bu']
                            const selectedBusinessUnits = activeOptions.filter((item) => selectedBusinessUnitParams?.includes(item.label));
                            if (selectedBusinessUnits?.length > 0){
                                setSelectedBu(selectedBusinessUnits);
                                setSelectedBuId(selectedBusinessUnits?.map((item) => item.label))
                            }

                        }

                        const region = data.find((item) => item.option_names === "Region");
                        if (region && region?.option_choice) {
                            const activeOptions = region.option_choice.filter(
                                (option) => option.status === "active"
                            );
                            setRegionType(activeOptions);
                            const selectedRegionParams = getQueryParams()['region']
                            const selectedRegions = activeOptions.filter((item) => selectedRegionParams?.includes(item.label))
                            if (selectedRegions?.length > 0) {
                                setSelectedRegion(selectedRegions);
                                setSelectedRegionId(selectedRegions?.map(item => item.label));
                            } /// NEED to Check
                        }
                    }
                }

            } catch (error) {
                // Handle errors
                console.error("Error fetching customer data", error);
            }
        }
    };


    const handleHide = () => {
        setVisible(false);
        getPipelineDetails()
        if (props.showCreateNew) {
            props.hidePopUp(false)
        }
    };

    const show = (position) => {
        if (addPrivilege) {
            setPosition(position);
            setVisible(true);
            setShowCreateNew(true);
        } else {
            toastRef.current.showToast({
                type: "error",
                message: "Permission Denied",
            });
        }
    };


    const generateBusinessUnitOptions = (details) => {
        if (details) {
            // Filter unique business units
            const uniqueBU = details.filter((bu, index, self) =>
                index === self.findIndex((b) => b.business_unit === bu.business_unit)
            );

            // Map to the options format required for MultiSelectElement
            const options = uniqueBU.map((bu) => ({
                value: bu.business_unit, // Ensure this is a unique identifier
                label: bu.business_unit // Ensure this is the label to display
            }));
            // Return the formatted options
            // setBusinessUnitType(options);


            const uniqueBranches = details?.filter((branchDetails, index, self) =>
                index === self.findIndex((b) => b.branch_name === branchDetails.branch_name)
            ) || [];

            const branchOptions = uniqueBranches.map((branch) => ({
                value: branch,
                label: branch.branch_name,
            }));
            setBranchTypes(branchOptions);

            if (Array.isArray(bidLeaders)) {
                const leaderOptions = bidLeaders.map((name) => ({
                    value: name,
                    label: name
                }));
                setBidLeadersOption(leaderOptions);
                const selectedBidLeaderParams = getQueryParams()['leader']
                const selectedBidLeaders = leaderOptions.filter((item) => selectedBidLeaderParams?.includes(item.label))
                if (selectedBidLeaders?.length > 0) {
                    setSelectedLeader(selectedBidLeaders?.map((item) => item.value));
                }
            }

            const uniqueStatus = details?.filter((bidStatus, index, self) =>
                index === self.findIndex((b) => b.bid_status === bidStatus.bid_status)
            ) || [];

            const statusOptions = uniqueStatus.map((branch) => ({
                value: branch,
                label: branch.bid_status,
            }));

            // setProjectStatus(statusOptions);



            const uniqueSector = details?.filter((sector, index, self) =>
                index === self.findIndex((b) => b.sector === sector.sector)
            ) || [];

            const sectorOptions = uniqueSector.map((sector) => ({
                value: sector,
                label: sector.sector,
            }));

            setSectorTypes(sectorOptions);



        }
        return [];
    };



    useEffect(() => {
        // Call the function to generate options and set the state
        generateBusinessUnitOptions(pipelineDetails);
    }, [pipelineDetails]);

    const setQueryParams = (paramObj) => {
        const existingParams = new URLSearchParams(location.search);
        for (const [key, value] of Object.entries(paramObj)) {
            if (value === null || value === undefined || (Array.isArray(value) && value?.length === 0 )) {
                existingParams.delete(key);
            } else {
                existingParams.set(key, value.toString());
            }
        }
        navigate({
            pathname: location.pathname,
            search: `?${existingParams.toString()}`,
        });
    };

    const getQueryParams = () => {
        const searchParams = new URLSearchParams(location.search);
        const paramObj = {};
        for (const [key, value] of searchParams) {
          paramObj[key] = value;
        }
        return paramObj;
    };

    const clearAllQueryParams = () => {
        navigate({
            pathname: location.pathname,
            search: '',
        });
    };

    const handleSelection = (event) => {
        setSelectedBranch(event);
        // Extract the _id values from the selected branches
        const ids = event.map(item => item._id);
        setQueryParams({ branch: ids});
        setSelectedBranchId(ids);
    };



    const handleBUSelection = (selectedOptions) => {
        // Handle selection change
        setSelectedBu(selectedOptions);
        const ids = selectedOptions.map(item => item.label);
        setQueryParams({ bu: ids})
        setSelectedBuId(ids);
    };

    const handleBranchSelection = (selectedOptions) => {
        // Handle selection change
        setSelectedBranch(selectedOptions);
        // const ids = selectedOptions.map(item => item._id);
        // setSelectedBranchId(ids);
    };

    const handleLeaderSelection = (selectedOptions) => {
        // Handle selection change
        setSelectedLeader(selectedOptions);
        const ids = selectedOptions.map(item => item.text);
        setQueryParams({ leader: selectedOptions});
        setSelectedLeaderId(ids);
    };

    const handleStatusSelection = (selectedOptions) => {
        // Handle selection change
        setSelectedStatus(selectedOptions);
        const ids = selectedOptions.map(item => item.label);
        setQueryParams({ status: ids})
        setSelectedStatusId(ids);
    };

    const handleOppTypeSelection = (selectedOptions) => {
        // Handle selection change
        setSelectedOppType(selectedOptions);
        const ids = selectedOptions.map(item => item.text);
        setQueryParams({ oppType: ids});
        setSelectedOppTypeId(ids);
    };
    const handleEsgProjectType = (selectedOptions) => {
        // Handle selection change
        setSelectedEsgProjectType(selectedOptions);
        const ids = selectedOptions.map(item => item.label);
        setQueryParams({ esgProject: ids});
        setSelectedEsgProjectTypeId(ids);
    };

    const handleSectorSelection = (selectedOptions) => {
        setSelectedSector(selectedOptions);
        // Extract the _id values from the selected branches
        const ids = selectedOptions.map(item => item.label);
        setQueryParams({ sector: ids})
        setSelectedSectorId(ids);
    };

    const handleRegionSelection = (selectedOptions) => {
        setSelectedRegion(selectedOptions);
        // Extract the _id values from the selected branches
        const ids = selectedOptions.map(item => item.label);
        setQueryParams({ region: ids});
        setSelectedRegionId(ids);
    };

    const handleTimePeriod = (selectedOptions) => {
        setSelectedTimePeriod(selectedOptions);
        setSelectedTimePeriodId(selectedOptions);
        setQueryParams({ tp: selectedOptions})
    };

    const handleSectorTypeSelection = (selectedOptions) => {
        // Handle selection change
        setSelectedSectorType(selectedOptions);
    };

    const handleFavouritesSelection = (event) => {
        setFavouriteStatus(event);
        setSelectedFavourites(event);
        setQueryParams({ favourite: event})
    }

    useEffect(() => {
        getPipelineDetails();
    }, [selectedBuId, selectedBranchId, selectedLeaderId, selectedSectorId, selectedRegionId, selectedEsgProjectTypeId, selectedStatusId, selectedOppTypeId, selectedTimePeriodId, selectedFavourites]);

    const onPage = (event) => {
        setLazyParams({
            ...lazyParams,
            first: event.first,
            rows: event.rows,
            page: event.page,
        });
    };

    const onSort = (e) => {
        let newSortField = e.sortField;
        let newSortOrder = e.sortOrder;

        // Check if the same column is clicked
        if (lazyParams.sortField === newSortField) {
            // If currently sorted ascending, switch to descending
            if (lazyParams.sortOrder === 1) {
                newSortOrder = -1; // Set to descending
            }
            // If currently sorted descending, remove sorting
            else if (lazyParams.sortOrder === -1) {
                newSortField = 'updated_timestamp'; // Remove sorting
                newSortOrder = -1; // Remove sorting
            }
        }
        setLazyParams((prevParams) => ({
            ...prevParams,
            sortField: newSortField,
            sortOrder: newSortOrder,
        }));
    };

    const dropdownRef = useRef(null);
    const handleOutsideClick = (event) => {
        if (showDropdown) {
            const target = event.target;
            const dropdownButton = document.querySelector('.clear-filter-button');
            const dropdownContent = document.querySelector('.s-field');
            const multiSelectInput = document.querySelector('.p-multiselect-filter');

            // Check if the clicked element is not in the dropdown, the button, or any MultiSelect/single select items
            if (
                !dropdownContent.contains(target) &&
                target !== dropdownButton &&
                target !== multiSelectInput &&
                !target.closest('.p-multiselect-item') && // MultiSelect items
                !target.closest('.p-dropdown-item') // Single select dropdown items
            ) {
                setShowDropdown(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showDropdown]);

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (

        <div className="group-table-component">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="header-design">
                <div>
                </div>
            </div>
            <div className="group-table-buttons">
                <div className="d-flex">
                    <div className="delete-button">
                        {
                            updatedReferenceData.length > 0 &&
                            <ButtonElement
                                className="delete-button-icon"
                                type="button"
                                icon="pi pi-trash"
                                onClick={() => confirmDeleteProduct()}
                            />
                        }
                    </div>
                    <div className="delete-button ml-20">
                        {
                            updatedReferenceData.length === 1 &&
                            <ButtonElement
                                className="delete-button-icon"
                                type="button"
                                icon="pi pi-clone"
                                onClick={() => confirmCloneProject()}
                            />
                        }
                    </div>
                </div>
                {
                    !props.hideDataTable &&
                    <div className="group-table-search">
                        <HeaderSearchBar
                            value={searchQuery}
                            onChange={(e) => handleSearchChange(e)}
                            onClick={handleClearFilter}
                        />
                        <ButtonElement className="clear-filter-button" icon="pi pi-filter-slash" onClick={resetFilter} />
                        <div className='p-relative' ref={dropdownRef}>
                            <ButtonElement className="clear-filter-button" icon="pi pi-filter" onClick={toggleDropdown} />
                            {showDropdown && (
                                <>
                                    <div className='s-field'>
                                        <div className='new-field w-100'>
                                            {
                                                havingBranch && branchIdFromLS.branch_key == 'main' &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(commanFieldsNew, { field_name: 'Branch' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedBranch}
                                                            optionLabel="branch_name"
                                                            options={branchDetails}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Business Unit'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(commanFieldsNew, { field_name: 'Business Unit' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedBu}
                                                            optionLabel="label"
                                                            options={businessUnitType}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleBUSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Bid Leader'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(projectFieldsNew, { field_name: 'Bid Leader' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedLeader}
                                                            optionLabel="label"
                                                            options={bidLeadersOption}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleLeaderSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Bid Status'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(projectFieldsNew, { field_name: 'Bid Status' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedStatus}
                                                            optionLabel="label"
                                                            options={projectStatus}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleStatusSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['winWork Stage'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(projectFieldsNew, { field_name: 'WinWork Stage' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedOppType}
                                                            optionLabel="text"
                                                            options={oppTypes}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleOppTypeSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Services'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(commanFieldsNew, { field_name: 'Services' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedEsgProjectType}
                                                            optionLabel="label"
                                                            options={esgProjectType}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleEsgProjectType(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Sector'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(commanFieldsNew, { field_name: 'Sector' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedSector}
                                                            optionLabel="label"
                                                            options={sectorType}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleSectorSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Region'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(commanFieldsNew, { field_name: 'Region' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={selectedRegion}
                                                            optionLabel="label"
                                                            options={regionTypes}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleRegionSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Time Period'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(dashBoardFieldsNew, { field_name: 'Time Period' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <SingleSelectElement
                                                            value={selectedTimePeriod}
                                                            optionLabel="text"
                                                            options={(timePeriod != undefined && timePeriod.length > 0) ? timePeriod : []}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleTimePeriod(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                filterPermissions['Favourites'] &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            {_.find(projectFieldsNew, { field_name: 'Favourites' })?.display_name}:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <SingleSelectElement
                                                            value={selectedFavourites}
                                                            optionLabel="label"
                                                            options={(favourites != undefined && favourites.length > 0) ? favourites : []}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleFavouritesSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        {
                            !customer.isRestricted &&
                            <ButtonElement
                                className="clear-filter-button"
                                type="button"
                                icon="pi pi-plus"
                                label="New"
                                onClick={() => show("right")}
                            />
                        }
                        <div>
                            <ButtonElement className="upload-button ml-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                        </div>
                    </div>
                }
            </div>
            {
                showCreateNew &&
                <CreateNewPortfolio
                    branch={branch}
                    branches={branches}
                    branchDetails={branchDetails}
                    pipelineInfo={stakeHolderDetails}
                    customer={customer}
                    customerId={customerId}
                    custmerDetails={custmerDetails}
                    customerTableData={customerTableData}
                    relationshipOwner={relationshipOwner}
                    visible={visible}
                    position={position}
                    onHide={handleHide}
                    pipelineVisible={pipelineVisible}
                    projectSectionsNew={projectSectionsNew}
                    projectFieldsNew={projectFieldsNew}
                    commanFieldsNew={commanFieldsNew}
                    havingBranch={havingBranch}
                    branchIdFromLS={branchIdFromLS}
                    clientFieldsNew={clientFieldsNew}
                    branchSelected={branchSelected}
                    currency={currency}
                    tabPermissions={tabPermissions}
                    clientSectionsNew={clientSectionsNew}
                    commonFields={commonFields}
                    sectorType={sectorType}
                    bidLeadersOption={bidLeadersOption}
                    pricingPlan={pricingPlan}
                    oppTypes={oppTypes}
                />
            }
            {
                !props.hideDataTable &&
                <DataTable
                    dataKey="_id"
                    value={pipelineDetails}
                    columns={columns}
                    removeField={removeField}
                    rowClick={rowClick}
                    isPrompts={true}
                    searchQuery={searchQuery}
                    onPage={onPage}
                    lazyParams={lazyParams}
                    totalRecords={totalRecords}
                    onSort={onSort}
                    deleted={deleted}
                    cloned={cloneProject}
                />
            }
            <Dialog visible={deleteProductDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={`Delete ${_.find(moduleNames, { module_name: "Pipeline" })?.display_name}`} modal footer={deleteProductDialogFooter()} onHide={hideDeleteProductDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    <span className="table-description">
                        <span className="table-description">
                            Are you sure you want to delete this {_.find(moduleNames, { module_name: "Pipeline" })?.display_name}?
                        </span>
                    </span>
                </div>
            </Dialog>
            <Dialog visible={cloneProject} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={`Clone ${_.find(moduleNames, { module_name: "Pipeline" })?.display_name}`} modal footer={cloneFooter()} onHide={hideCloneDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className="col-md-3 pl-0">
                            <label className="form-label text-left">{`${_.find(moduleNames, { module_name: "Pipeline" })?.display_name} Name`}</label>
                        </div>
                        <div className='col pr-0'>
                            <InputTextElementElement
                                name="project_name"
                                onChange={(e) => setProjectName(e.target.value)}
                                className="w-full"
                                value={projectName}
                            />
                        </div>
                    </div>
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className="col-md-3 pl-0">
                            <label className="form-label text-left">{`${_.find(moduleNames, { module_name: "Clients" })?.display_name}`}</label>
                        </div>
                        <div className='col pr-0'>
                            <SingleSelectElement
                                id='clients'
                                name="clients"
                                options={(stakeHolderDetails != undefined && stakeHolderDetails.length > 0) ? stakeHolderDetails : []}
                                value={clientName}
                                onChangeValue={(e) => setClientName(e.target.value)}
                                optionLabel='client_name'
                                placeholder="-- Please select --"
                                maxSelectedLabels={1}
                                className="w-full"
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="portfolio_overview" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
